<template>
  <div id="management-user-info">
    <!-- info area -->
    <el-card class="box-card" shadow="never">
      <el-form :inline="false" :model="userInfo" class="demo-form-inline" label-width="100px" >
        <el-row>
          <el-col v-if="userInfo.id" :span="6">
            <el-form-item label="用户ID">
              <el-input v-model.trim="userInfo.id" :disabled="true" placeholder="用户ID" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户角色">
              <el-select v-model="userInfo.roleId" placeholder="请选择">
                <el-option :value="item.value" :label="item.label" v-for="item in userRoleList" :key="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="用户姓名">
              <el-input v-model.trim="userInfo.name" placeholder="用户姓名" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="所属机构">
              <el-cascader :props="{ multiple: true }" :options="institutionTree" v-model="userInfo.institutionInfo"
                expand-trigger="hover" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱">
              <el-input v-model.trim="userInfo.email" placeholder="邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="密码">
              <el-input v-model.trim="userInfo.password" placeholder="密码" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号">
              <el-input v-model.trim="userInfo.mobile" placeholder="手机号" />
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="状态">
              <el-select v-model="userInfo.status" placeholder="请选择">
                <el-option label="启用" value="0" />
                <el-option label="禁用" value="1" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="度言员工编号">
              <el-input v-model.trim="userInfo.dyAccountId" placeholder="度言员工编号" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="agentId">
          <div class="el-form-item__label">
            创建时间：{{ modifyInfo.createAt }} 创建人：{{ modifyInfo.creator }}
          </div>
        </el-row>

        <el-row v-if="agentId">
          <div class="el-form-item__label">
            修改时间：{{ modifyInfo.updateAt }} 修改人：{{ modifyInfo.updater }}
          </div>
        </el-row>
      </el-form>
      <!-- button area -->
      <div class="button-area">
        <el-button  type="primary" @click="save">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as manageApi from '../../api/manage.js'
import { getDictionaryList } from "@/api/manage";

export default {
  name: 'management-user-info',
  data() {
    return {
      headerRowStyle: {
        'background-color': '#6584b4'
      },
      userInfo: {},
      modifyInfo: {},
      institutionTree: [],
      userRoleList: []
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'manageAgentInfo'
    ]),
    agentId() {
      return this.$route.params.uid
    }
  },
  watch: {
    '$route'() {
      this.loadInstitutions()
      if (this.agentId) {
        this.loadUser()
      }
    },
    userInfo: {
      handler(n, o) {
        if (n.institutionInfo && n.institutionInfo.length) {
          this.institutionTree.forEach(item => {
            if (item.value !== n.institutionInfo[0][0]) item.disabled = true
          })
        } else {
          this.institutionTree.forEach(item => {
            delete item['disabled']
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  async created() {
    // 用户角色
    const fdRoleRes = await getDictionaryList("fd_role");
    fdRoleRes.data.map((item) => {
      this.userRoleList.push({
        label: item.dictLabel,
        value: Number(item.dictValue),
      });
    });
    await this.loadInstitutions()
    // 用户回显
    if (this.agentId) {
      await this.loadUser()
    }
  },
  methods: {
    ...mapActions([
      'fetchUserInfo'
    ]),
    // 获取下拉机构列表
    async loadInstitutions() {
      const res = await manageApi.fetchInstitutionTree(this.$route.params.uid)
      this.institutionTree = res.data
    },
    // 获取用户信息
    loadUser() {
      this.fetchUserInfo({ id: this.agentId }).then(() => {
        const user = this.manageAgentInfo
        const institutionInfoArr = []
        if (user.workQueueIds && user.workQueueIds.length) {
          user.workQueueIds.forEach(item => {
            institutionInfoArr.push([user.institutionId, item])
          })
        }
        this.$set(this, 'userInfo', {
          roleId: user.role ? user.role : '1',
          institutionInfo: user.institutionId ? institutionInfoArr : [],
          ...user
        })
        this.modifyInfo = {
          createAt: user.createdAt ? user.createdAt : null,
          creator: user.creator ? user.creator : '-',
          updateAt: user.updatedAt ? user.updatedAt : null,
          updater: user.updator ? user.updator : '-'
        }
      })
    },
    preparePostData() {
      this.userInfo.opId = this.currentUser.id
      // let item = []
      // for (let i = 0; i < this.institutionTree.length; i++) {
      //   item = this.institutionTree[i].children.filter(item => item.value === this.userInfo.institutionInfo[1])
      //   if (item.length) break
      // }
      // const group = item[0].label
      this.userInfo.institutionId = this.userInfo.institutionInfo.length===0 ? '' : this.userInfo.institutionInfo[0][0]
      const workQueueIds = []
      if (this.userInfo.institutionInfo.length) {
        this.userInfo.institutionInfo.forEach(item => {
          workQueueIds.push(item[1])
        })
      }
      this.userInfo.workQueueIds = workQueueIds
      // this.userInfo.group = group
    },
    save() {
      // 这里手动加一下，dirty fix
      // TODO: clear dirty fix
      if (!this.userInfo.name) {
        this.$message.warning('请先输入用户姓名')
        return
      }
      // if (!this.userInfo.email) {
      //   this.$message.warning('请先输入邮箱')
      //   return
      // }
      if (!this.userInfo.institutionInfo) {
        this.$message.warning('请先选择所属机构')
        return
      }
      if (!this.userInfo.roleId) {
        this.userInfo.roleId = '1'
      }
      this.preparePostData()
      manageApi.postAgentInfo(this.userInfo).then((res) => {
        if (!res) {
          this.userInfo.roleId = ''
          return
        }
        if (res.data === 'success') {
          // this.$router.replace({ name: 'manage-user-info', params: { uid: res.data.data.id }})
          this.$notify({
            title: '保存成功！',
            message: '2秒自动关闭',
            type: 'success',
            duration: 5000
          })
          setTimeout(() => {
            window.history.go(-1)
          }, 2000)
        } else {
          this.$notify.error({
            title: '出错了！',
            message: res.data.msg,
            type: 'error',
            duration: 5000
          })
        }
      })
    },
    back() {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.button-area {
  float: right;
  margin-bottom: 20px;
}

#management-user-info .el-input {
  width: auto;
}
</style>
